import React from "react";
import CreonSurvey from "./fusion";

export default function FusionDoctorKazakhstanSurvey(props) {
  return (
    <CreonSurvey
      {...props}
      projectId="creon_consumers_ru_kz_doc"
      segment="doc"
    />
  );
}
